import { Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AwaitModules, ComponentSync, getElementCenterPos, LL_H_C, LL_V_L, ModuleFE_AppConfig, ModuleFE_BrowserHistory, ModuleFE_MouseInteractivity, TS_ComponentTransition } from '@nu-art/thunderstorm-frontend/index';
import './DiscussionsView.scss';
import { Discussion_Renderer } from '../discussion/Discussion_Renderer.js';
import { dbObjectToId, logicalXOR, MUSTNeverHappenException, sortArray } from '@nu-art/ts-common';
import { ICONS } from '@app/styles';
import { DiscussionsView_FilterOptionsMenu } from './DiscussionView_FilterOptionsMenu.js';
import { Renderer_NewDiscussion } from '../discussion/Renderer_NewDiscussion.js';
import { ManagerUI_ItemId, ManagerUI_ItemType } from '@app/styles';
import { ModuleFE_Message, ModuleFE_Topic } from '@nu-art/ts-messaging-frontend';
import { ModuleFE_Discussion, PermissionKeyFE_MessagingUI_Release, QScrollWrapper, storage_FilterSelected } from '@app/hcs-frontend';
import { AccessLevel } from '@nu-art/permissions-frontend/modules/ModuleFE_PermissionsAssert';
const modulesToAwait = [ModuleFE_Discussion, ModuleFE_Topic, ModuleFE_Message];
class DiscussionsView_Class extends ComponentSync {
    transitionTimeout = 300;
    // ######################### Life Cycle #########################
    __onLoginStatusUpdated() {
        this.reDeriveState({ showDiscussionsPanel: false });
    }
    __onMessagesUpdated(...params) {
        this.reDeriveState();
    }
    __onDiscussionsUpdated(...params) {
        this.reDeriveState({ newDiscussion: undefined });
    }
    __discussionsViewOptionsChanged() {
        this.reDeriveState();
    }
    __showDiscussions(props) {
        if (props.topicId) {
            const topic = ModuleFE_Topic.cache.unique(props.topicId);
            if (!topic)
                throw new MUSTNeverHappenException(`Was given a topicId, for a topic that does not exist! ${props.topicId}`);
            return this.reDeriveState({
                showDiscussionsPanel: true,
                focusedObject: topic
            });
        }
        if (props.newDiscussion) {
            return this.setState({
                newDiscussion: props.newDiscussion,
                showDiscussionsPanel: true
            });
        }
        if (this.state.showDiscussionsPanel)
            return this.reDeriveState({ showDiscussionsPanel: false });
        const _focusedObject = storage_FilterSelected.get(false) ? this.state.focusedObject : undefined;
        this.reDeriveState({ showDiscussionsPanel: true, focusedObject: _focusedObject, newDiscussion: undefined });
    }
    __onUrlParamsChanged() {
        const refId = ModuleFE_BrowserHistory.getQueryParameter(ManagerUI_ItemId);
        const type = ModuleFE_BrowserHistory.getQueryParameter(ManagerUI_ItemType);
        const focusedObject = logicalXOR(!!refId, !!type) ? undefined : { type, refId };
        this.reDeriveState({ focusedObject: focusedObject });
    }
    deriveStateFromProps(nextProps, state) {
        state.discussions = this.getDiscussionsToShow(state.focusedObject);
        return state;
    }
    getDiscussionsToShow(focusedObject) {
        let discussions = ModuleFE_Discussion.cache.all();
        //Filter discussions by focused object(specific variable, or another db object) - show only and all discussions about this object
        const focusedTopicIds = this.getTopicsFromFocusedObject(focusedObject).map(dbObjectToId);
        if (focusedTopicIds.length > 0)
            // if()
            discussions = discussions.filter(discussion => focusedTopicIds.includes(discussion.topicId));
        //Filter discussions by resolved status, and sort by last message shown on top.
        const shouldShowResolvedDiscussions = ModuleFE_Discussion.shouldShowResolvedDiscussions();
        return sortArray(discussions.filter(discussion => shouldShowResolvedDiscussions
            ? true
            : discussion.status !== 'resolved'), discussion => ModuleFE_Discussion.getLastMessageForDiscussion(discussion)?.__created);
    }
    getTopicsFromFocusedObject(focusedObject) {
        if (!focusedObject)
            return [];
        return ModuleFE_Discussion.getTopicsByObjectRef(focusedObject.type, focusedObject.refId);
    }
    renderDiscussionsSearch() {
        return _jsx("div", {});
        //todo replace with search dropdown
        return _jsxs(LL_H_C, { children: [_jsx(ICONS.search.component, {}), "Search"] });
    }
    renderSortPopUp(e) {
        const discussionView = {
            id: 'display-options-menu',
            content: () => {
                this.logInfo(`popup render content, filterSelected: ${this.state.filterSelected}`);
                return _jsx(DiscussionsView_FilterOptionsMenu, {});
            },
            modalPos: { x: -1, y: 1 },
            offset: { y: 20, x: 15 },
            originPos: getElementCenterPos(e.currentTarget)
        };
        try {
            ModuleFE_MouseInteractivity.showContent(discussionView);
            this.logInfo('Clicking on display options');
        }
        catch (e) {
            this.logWarning(e);
        }
    }
    renderDisplayOptionsMenu() {
        return _jsxs(LL_H_C, { className: 'display-options-menu', children: [this.renderDiscussionsSearch(), _jsx(ICONS.displayOptions.component, { className: 'sort-discussion-button', onClick: (e) => this.renderSortPopUp(e) })] });
    }
    renderNewDiscussion = () => {
        if (!this.state.newDiscussion)
            return;
        return _jsx(Renderer_NewDiscussion, { type: this.state.newDiscussion.type, refId: this.state.newDiscussion.refId });
    };
    renderLoader = () => _jsx(_Fragment, {});
    hasUIPermission = () => {
        try {
            return PermissionKeyFE_MessagingUI_Release.getAccessLevel() === AccessLevel.HasAccess;
        }
        catch (e) {
            return false;
        }
    };
    renderImpl = () => {
        if (!this.hasUIPermission())
            return _jsx(_Fragment, {});
        return _jsx(AwaitModules, { modules: modulesToAwait, children: _jsx(TS_ComponentTransition, { trigger: this.state.showDiscussionsPanel, transitionTimeout: this.transitionTimeout, children: _jsxs(LL_V_L, { className: 'quai-discussions-container', children: [this.renderDisplayOptionsMenu(), _jsxs(QScrollWrapper, { className: 'discussions-scrolling-container', children: [this.renderNewDiscussion(), this.state.discussions.map(discussionToRender => _jsx(Discussion_Renderer, { discussion: discussionToRender }, discussionToRender._id)).reverse()] })] }) }) });
    };
    render() {
        return _jsx(AwaitModules, { modules: [ModuleFE_AppConfig], children: _jsx(this.renderImpl, {}) });
    }
}
export const DiscussionsView = () => {
    return _jsx(DiscussionsView_Class, {});
};
//# sourceMappingURL=DiscussionsView.js.map